import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class GetMTAdminAuthApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/auth/MTAdminAuth',
      requesterInfo,
    })
  }

  public async getAuth(): Promise<boolean> {
    return await this.getAsync<boolean>()
  }
}
